import { useFiltersContext } from "@core/FiltersContext";
import { useMemo } from "react";

export const BENCHMARK_NORM_ID = 4;

export function useBenchmarkNorm() {
    const {
        options: { norms },
    } = useFiltersContext();

    return useMemo(
        () => norms.find(
            i => i.id === BENCHMARK_NORM_ID,
        ),
        [norms]
    );
}